import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
    private destroy$ = new Subject()

    constructor(
        private translate: TranslateService
    ) {
        super();
        this.translate.onLangChange
            .pipe(takeUntil(this.destroy$))
            .subscribe((event) => {
                this.getAndInitTranslations();
            });

        this.getAndInitTranslations();
    }

    getAndInitTranslations() {
        this.itemsPerPageLabel = this.translate.instant('@itemsPerPage');
        this.firstPageLabel = this.translate.instant('@firstPage');
        this.nextPageLabel = this.translate.instant('@nextPage');
        this.previousPageLabel = this.translate.instant('@previousPage');
        this.lastPageLabel = this.translate.instant('@lastPage');
        this.changes.next();

    }

    getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0 || pageSize === 0) {
            return `0 / ${length}`;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} / ${length}`;
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
